import { createFileRoute } from '@tanstack/react-router'
import DashboardWatermarkPage from '@/pages/dashboard/dashboard-watermark-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/watermark',
)({
  component: function WatermarkRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <DashboardWatermarkPage />
      </ProtectedRoute>
    )
  },
})
